/**
 * Project : workspace
 * File    : StoreCurrencyNavGraph.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package navigation.graph.store.currency

import androidx.navigation.NavGraph
import androidx.navigation.compose.composable
import androidx.navigation.createGraph
import navigation.base.FriendlyWindow
import navigation.route.store.currency.StoreCurrencyNavRoute
import presentation.screens.business.store.currency.MyBusinessStoreCurrency

/**
 * Represents the store currency nav graph class.
 */

class StoreCurrencyNavGraph {
    fun navGraph(): NavGraph {
        val graph =
            FriendlyWindow.Companion.navigationController?.createGraph(startDestination = StoreCurrencyNavRoute.HOME) {
                composable(route = StoreCurrencyNavRoute.HOME) {
                    MyBusinessStoreCurrency().Content()
                }
            }
        return graph!!
    }
}